<template>
  <div class="Register-Container">
    <img :src="splashUrl" alt="" class="splashImg" />
    <div class="backArow" @click="$router.push('login')">
      <img src="@/assets/arow.svg" alt="" />
    </div>
    <div class="register-form">
      <div class="top-right-icons">
        <div class="top-right-button" data-cy="header.language">
          <language-dropdown />
        </div>
      </div>
      <form @submit.prevent="nextStep">
        <img src="@/assets/logo.png" class="logo" />
        <h1>{{ $t('auth.register.callToActionTitle') }}</h1>
        <h3>{{ $t('auth.register.personnalData') }}</h3>

        <vv-form-text-input
          label="username"
          id="username"
          v-model="username"
          :validate="'required|email'"
          placeholder="jean.pascal@gmail.com"
          class="textGras input"
        />

        <vv-form-text-input
          label="password"
          id="password"
          type="password"
          v-model="password"
          :is-register="true"
          placeholder="azerty"
          :validate="{ required: true }"
          class="textGras input"
        />

        <vv-form-text-input
          v-if="registerFields.lastname !== undefined"
          label="lastname"
          id="lastname"
          v-model="lastname"
          :validate="registerFields.lastname.mandatory ? 'required' : ''"
          placeholder="Pascal"
          class="textGras input"
        />

        <vv-form-text-input
          v-if="registerFields.firstname !== undefined"
          label="firstname"
          id="firstname"
          v-model="firstname"
          :validate="registerFields.firstname.mandatory ? 'required' : ''"
          placeholder="Jean"
          class="textGras midelForm"
        />

        <vv-form-mask-input
          v-if="registerFields.birthday !== undefined"
          id="birthday"
          label="birthday"
          name="birthday"
          v-model="birthday"
          placeholder="birthdayPlaceholder"
          :cleave="{ date: true, datePattern: ['d', 'm', 'Y'] }"
          :validate="'required|date_format:dd/MM/yyyy|legalAge'"
          class="textGras input birthday"
        />
        <p class="Warning-minor">{{ $t('auth.login.minorWarnings') }}</p>

        <div class="endBox">
          <vv-form-checkbox-input
            class="acceptCond"
            label="acceptCondition"
            id="acceptCondition"
            v-model="acceptCondition"
          />
          <vv-form-checkbox-input label="newsletter" id="newsletter" v-model="newsletter" />
        </div>
        <p :hidden="false" class="Register-Text more-infos">{{ $t('auth.login.moreInfos') }}</p>

        <div class="choice-buttons">
          <validate-form-button
            @click="nextStep"
            :full="false"
            label="auth.register.nextPage"
            class="btContinu"
          />

          <validate-form-button
            @click="registerUser"
            :isLoading="loading"
            :hidden="false"
            label="auth.register.callToAction"
            class="btCreate"
          />
        </div>

        <span class="Register-Text alcool-warning">{{ $t('auth.login.alcoolWarning') }}</span>
      </form>
    </div>
  </div>
</template>

<script>
import { REGISTER_USER } from '@/store/modules/user/types'
import ValidateFormButton from '@/components/common/ValidateFormButton'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import VvFormMaskInput from '@/components/common/forms/VvFormMaskInput'
import VvFormCheckboxInput from '@/components/common/forms/VvFormCheckboxInput'
import userMixin from '@/mixins/user'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'
import * as types from '@/store/modules/user/types'
import { SIGNIN_USER } from '@/store/modules/user/types'
import { splash_screen_url } from '@/lib/remote-config/constants'
import remoteConfig from '@/lib/remote-config'
import { SET_FORM_USER_INFORMATIONS } from '@/store/modules/user/types'
import LanguageDropdown from '@/components/language/LanguageDropdown'

export default {
  name: 'PreRegister',
  mixins: [userMixin],
  components: {
    ValidateFormButton,
    VvFormTextInput,
    VvFormMaskInput,
    VvFormCheckboxInput,
    LanguageDropdown
  },
  data: () => ({
    splashUrl: '',
    username: '',
    password: '',
    gender: '',
    loading: false,
    firstname: '',
    lastname: '',
    birthday: '',
    phone: '',
    shippingAddress: '',
    city: '',
    country: '',
    shippingPostalCode: '',
    newsletter: false,
    acceptCondition: false,
    local: 'fr-FR'
  }),

  // preregister seul -> billing x4 dans bdd vides / rien d'autre
  // pre et register -> billing x4 dans bdd pleins / rien d'autre

  methods: {
    getSelect(selectId) {
      var selectElmt = document.getElementById(selectId)
      return selectElmt.value
    },
    registerUser: async function() {
      const result = await this.$validator.validateAll()
      if (!result) {
        return
      }

      if (this.password.length < 6) {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.auth/weak-password') })
        return
      }

      if (
        this.registerFields.birthday !== undefined &&
        (this.birthday == '' || this.birthday == null)
      ) {
        return
      }

      if (this.acceptCondition == false) {
        let accept = document.querySelector('.acceptCond')
        accept.style.color = 'red'
        return
      }

      let add = document.querySelector('.btContinu')
      add.style.display = 'none'

      this.loading = true

      const [error, response] = await this.$store.dispatch(REGISTER_USER, {
        username: this.username,
        password: this.password,
        gender: this.gender,
        firstname: this.firstname,
        lastname: this.lastname,
        birthday: this.birthday,
        phone: this.phone,
        shippingAddress: this.shippingAddress,
        city: this.city,
        country: this.country,
        shippingPostalCode: this.shippingPostalCode,
        newsletter: this.newsletter,
        acceptCondition: this.acceptCondition,
        language: this.local
      })
      if (error || response.data.error) {
        if (error && error.code) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code) })
        } else if (response.data.error) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.' + response.data.reason)
          })
        } else {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.custom/internal-error')
          })
        }
      } else {
        this.$store.commit(SET_FORM_USER_INFORMATIONS, {})
        if (response.data.emailVerified) {
          // Force log the user
          await this.$store.dispatch(SIGNIN_USER, {
            username: this.username,
            password: this.password
          })
        } else {
          this.$store.commit(types.REGISTER_USER, { email: this.username, validated: false })

          this.$router.push({
            name: 'confirm-registration'
          })
        }
      }

      this.loading = false
      add.style.display = 'block'
    },
    nextStep: async function() {
      const result = await this.$validator.validateAll()
      if (!result) {
        return
      }
      // console.log(this.acceptCondition)
      if (this.acceptCondition == false) {
        let accept = document.querySelector('.acceptCond')
        accept.style.border = 'thin dotted red'
        accept.style.borderRadius = '10px'

        return
      }

      this.$store.commit(SET_FORM_USER_INFORMATIONS, {
        lastname: this.lastname,
        firstname: this.firstname,
        username: this.username,
        password: this.password,
        birthday: this.birthday,
        newsletter: this.newsletter,
        acceptCondition: this.acceptCondition
      })
      this.$router.push({
        name: 'register'
      })
    }
  },
  computed: {
    registerFields() {
      try {
        return JSON.parse(remoteConfig.getString('register_fields'))
      } catch (error) {
        return {}
      }
    },

    languageSelected() {
      const languages = remoteConfig.getString('languages')

      if (languages) {
        return languages
          .split('|')
          .map(language => ({ value: language, text: this.$t(`languages.${language}`) }))
      }
      return []
    }
  },
  mounted() {
    this.splashUrl = remoteConfig.getString(splash_screen_url)
    if (!!this.$store.state.user.formUserInformations.firstname === true)
      this.firstname = this.$store.state.user.formUserInformations.firstname
    if (!!this.$store.state.user.formUserInformations.lastname === true)
      this.lastname = this.$store.state.user.formUserInformations.lastname
    if (!!this.$store.state.user.formUserInformations.username === true)
      this.username = this.$store.state.user.formUserInformations.username
    if (!!this.$store.state.user.formUserInformations.password === true)
      this.password = this.$store.state.user.formUserInformations.password
    if (!!this.$store.state.user.formUserInformations.birthday === true)
      this.birthday = this.$store.state.user.formUserInformations.birthday
    if (this.isUserLogged) {
      this.$router.push({ name: 'home' })
      return
    }
  },
  watch: {
    isUserLogged(newState) {
      if (newState) {
        // Automatically logged
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top-right-icons {
  align-self: flex-end;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Helvetica', sans-serif;
  max-width: 80000px;
  background-color: white;
  border-radius: 13px;
  position: absolute;
  top: 25px;
  .top-right-button {
    width: 40px;
    height: 30px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
}

.textGras {
  font-weight: 700;
}
.language {
  margin-top: 5px;
}
.more-infos {
  width: 90%;
  margin-top: 0px;
  font-size: 0.9rem;
  text-align: justify;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  h1 {
    width: 100%;
    text-align: center;
    letter-spacing: 0px;
    color: #404040;
    opacity: 1;
    font-weight: 400;
    margin: 10px;
  }
  h3 {
    width: 700px;
    text-align: center;
    letter-spacing: 0px;
    color: #404040;
    opacity: 1;
    font-weight: 300;
    margin: 10px;
  }
}

.splashImg {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  object-fit: cover;
  z-index: -1;
}

.selectLang {
  width: 100%;
  margin-top: 1%;
  margin-bottom: 1.5%;
}

.input {
  margin-bottom: 0px;
}

.logo {
  width: 100px;
  margin-bottom: 10px;
}

.midelForm {
  margin-bottom: 5px;
}

.btContinu,
.btCreate {
  margin: 3px;
}

.Register-Container {
  width: 100vw;
  height: 100vh;
  font-family: 'DM Sans', sans-serif;
}
.register-form {
  float: right;
  margin-right: 10%;
  margin-top: 8%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 500px;
  height: 600px;
  padding: 50px;
  background: #f8f6ef 0% 0% no-repeat padding-box;
  border-radius: 45px;
  background-color: rgba(248, 246, 239, 0.67);
}
.choice-buttons {
  display: flex;
}
.endBox {
  align-self: flex-start;
  margin-left: 5px;
  margin-bottom: 15px;
}
.acceptCond {
  display: block;
  position: relative;
  padding-left: 30px;
  padding-top: 3px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: rgb(0, 0, 0);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.gender-wrapper {
  margin: 6px 0;

  .gender-label {
    display: block;
  }
}

.Warning-minor {
  align-self: flex-end;
  font-size: 12px;
  margin: 0;
  margin-right: 3px;
  margin-bottom: 5px;
}
.alcool-warning {
  font-size: 0.8rem;
}
.backArow {
  position: fixed;
  top: 20px;
  left: 20px;
  transform: rotate(180deg);
  width: 40px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .backArow {
    width: 30px;
  }

  .Register-Container {
    width: 100vw;
    height: 100vh;
    font-family: 'DM Sans', sans-serif;
  }

  .register-form {
    margin-right: 10%;
    margin-top: 18%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 450px;
    height: 600px;
    background: #f8f6ef 0% 0% no-repeat padding-box;
    border-radius: 45px;
    background-color: rgba(248, 246, 239, 0.67);
  }
}

@media (max-width: 620px) {
  // 360     768     1024     1440     1920

  .endBox {
    margin-left: 16%;
    width: 65%;
  }
  .Register-Container {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    font-family: 'DM Sans', sans-serif;
  }

  .register-form {
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 250px;
    height: 550px;
    padding: 50px;
    background: #f8f6ef 0% 0% no-repeat padding-box;
    border-radius: 45px;
    background-color: rgba(248, 246, 239, 0.67);
  }
  form {
    margin-top: -15px;
  }

  .Warning-minor {
    margin-right: 65px;
  }
  .alcool-warning {
    margin-top: 5px;
  }

  h1 {
    display: none;
  }
  form h3 {
    width: 75%;
    margin-bottom: 0px;
    font-size: 0.9rem;
  }

  .Register-Text {
    font-size: 12px;
  }

  .choice-buttons {
    display: flex;
    flex-direction: column;
  }
  .backArow {
    width: 30px;
  }

  .more-infos {
    width: 66%;
    font-size: 0.9rem;
    text-align: center;
    margin-bottom: 4px;
  }
  .logo {
    width: 90px;
    margin-bottom: -5px;
  }
}
</style>
